<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <user-configuration-management />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import UserConfigurationManagement from "./UserConfigurationManagement/UserConfigurationManagement";
    export default {
        name: "UserConfigurationManagementPage",
        components: {UserConfigurationManagement}
    }
</script>

<style scoped>

</style>

